module.exports = __webpack_public_path__ + "front/img/10_1.988dea86.png";